<template>
	<el-dialog title="选择地点" v-model="isAddress" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page-container">
			<div class="" style="width: 100%; height: 100%">
				<div class="top-content">
					地址:
					<div class="searchbox mr-10 ml-20">
						<input style="width: 400px;" type="text" v-model="address" placeholder="输入详细地址"
							@keyup.enter="handleEnter" />
					</div>
					当前坐标: {{ point[0] }}, {{ point[1] }}
					<span class="btn bg-default mr-10 ml-20" v-on:click="submit()">确认地址</span>
				</div>
				<div id="map-container">
					<div id="container" :style="{ height: mapHeight + 'px' }"></div>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {
		throwStatement
	} from "@babel/types";
	export default defineComponent({
		name: "Address",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getAddressData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getAddressData = (addressvaule, lng, lat) => {
				context.emit("getAddressData", addressvaule, lng, lat);
			};
			onMounted(() => {
				nextTick(() => {
					data.mapHeight = document.querySelector(" #map-container").offsetHeight;
				});
			});
			const data = reactive({
				isAddress: false,
				searchWord: "",
				mapHeight: 400,

				center: [115.97539, 28.715532], //地图中心点
				point: [], //经纬度-lng lat
				map: null, //地图实例
				marker: null, //地图icon
				geocoder: null, //逆解析实例
				address: null //地址
			});
			//重置数据
			const init = (addressvalue) => {
				data.isAddress = true;
				data.center = [115.97539, 28.715532]; //地图中心点
				data.point = []; //经纬度-lng lat
				data.map = null; //地图实例
				data.marker = null; //地图icon
				data.geocoder = null; //逆解析实例
				data.address = addressvalue; //地址

				AMapLoader.load({
						key: "e43a295f15ed06c429ff79a20f5331f0",
						version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
						plugins: [
							"AMap.Geolocation",
							"AMap.AutoComplete",
							"AMap.PlaceSearch",
							"AMap.Geocoder",
							"AMap.IndexCluster",
						], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
						AMapUI: {
							// 是否加载 AMapUI，缺省不加载
							version: "1.1", // AMapUI 版本
							plugins: ["overlay/SimpleMarker"], // 需要加载的 AMapUI ui插件
						},
						Loca: {
							// 是否加载 Loca， 缺省不加载
							version: "2.0", // Loca 版本
						},
					})
					.then((AMap) => {
						// console.log(AMap)
						data.map = new AMap.Map("container", {
							//设置地图容器id
							viewMode: "3D", //是否为3D地图模式
							zoom: 10, //初始化地图级别
							center: [113.683515, 34.752721], //初始化地图中心点位置
							animateEnable: false,
						});
						//监听用户的点击事件
						data.map.on('click', e => {
							let lng = e.lnglat.lng
							let lat = e.lnglat.lat
							data.point = [lng, lat]
							// 增加点标记
							addMarker();
							// 获取地址
							getAddress();
						})
					})
					.catch((e) => {});

				if (data.address !== null && data.address !== undefined && data.address != "") {
					handleEnter();
				}


			};

			// 增加点标记
			const addMarker = () => {
				// 清除其他icon
				if (data.marker) {
					data.marker.setMap(null)
					data.marker = null
				}
				// 重新渲染icon
				// data.marker = new AMap.Marker({
				// 	icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
				// 	position: data.point, //icon经纬度
				// 	offset: new AMap.Pixel(-13, -30) //icon中心点的偏移量
				// })
				data.marker = new AMap.Marker({
					map: data.map,
					position: data.point,
					animation: "AMAP_ANIMATION_DROP"
				})
				data.marker.setMap(data.map) //设置icon
			};

			// 将经纬度转换为地址
			const getAddress = () => {
				// 这里通过高德 SDK 完成。
				data.geocoder = new AMap.Geocoder({
					city: '全国', //地理编码时，设置地址描述所在城市; 默认全国; 可选值：城市名（中文或中文全拼）、citycode、adcode
					radius: 1000, //逆地理编码时，以给定坐标为中心点; 默认1000; 取值范围(0-3000)
					extensions: 'all' //逆地理编码时，返回信息的详略; 默认值：base，返回基本地址信息; 默认值：base，返回基本地址信息
				})
				//调用逆解析方法 个人开发者调用量上限5000（次/日）
				data.geocoder.getAddress(data.point, function(status, result) {
					if (status === 'complete' && result.info === 'OK') {
						if (result && result.regeocode) {
							// this指向改变
							data.address = result.regeocode.formattedAddress
						}
					}
				})
			};

			// 重写AAddress.js 的 Geocoder 方法
			const Geocoder = (addr) => {
				if (addr != null && addr != "") {
					// document.getElementById("road").value = addr;
					var geocoder = new AMap.Geocoder({
						radius: 1000
					});

					geocoder.getLocation(addr, function(status, result) {
						console.log(status);
						console.log(result);
						if (status === 'complete' && result.info === 'OK') {
							geocoder_CallBack(result);

						} else {
							alert("没有搜索到您查找的地址！");
							proxy.$message.error("没有搜索到您查找的地址！");
						}
					})
				} else {}
			};

			const geocoder_CallBack = (data) => {
				var resultStr = "";
				var geocode = data.geocodes;
				if (geocode.length > 0) {
					AddPosition(geocode[0].location.getLng(), geocode[0].location.getLat())
				} else {
					alert("没有搜索到您查找的地址！")
				}
			};

			const AddPosition = (lng, lat, radius) => {
				// 清除其他icon
				if (data.marker) {
					data.marker.setMap(null)
					data.marker = null
				}

				data.point = [lng, lat]
				data.map.panTo(data.point);
				// 重新渲染icon
				// data.marker = new AMap.Marker({
				// 	icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
				// 	position: data.point, //icon经纬度
				// 	offset: new AMap.Pixel(-13, -30) //icon中心点的偏移量
				// })
				// data.marker.setMap(data.map) //设置icon

				data.marker = new AMap.Marker({
					map: data.map,
					position: data.point,
					animation: "AMAP_ANIMATION_DROP"
				})
				// data.marker.setMap(data.map) //设置icon

			};

			const handleEnter = () => {
				// 处理回车事件，例如提交表单或进行其他操作
				console.log('回车键被按下，输入值为:', data.address);
				// 这里可以添加更多的逻辑，比如调用API发送数据等
				data.point = [];
				Geocoder(data.address);
			};

			const dialogClosedHandle = () => {
				data.isAddress = false;
			};
			const closeModal = () => {
				data.isAddress = false;
			};
			const submit = async () => {
				if (data.point.length === 0) {
					proxy.$message.error("请先获取地址再确认");
					return;
				}
				data.isAddress = false;
				getAddressData(data.address, data.point[0], data.point[1]);
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getAddressData,
				dialogClosedHandle,
				submit,
				getAddress,
				addMarker,
				Geocoder,
				handleEnter,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 80px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.toolbar {
		position: absolute;
		bottom: 50px;
		left: 0;
		width: 100%;
		height: 100px;
		background-color: #fff;
		font-size: 20px;
		text-align: center;
		line-height: 50px;
	}
</style>